import React from 'react';

// helpers
import styled from 'styled-components';
import useTranslation from 'hooks/useTranslation';
import { colorsTheme } from 'resources/theme/styled/colors';

// Components
import { IconSVG, Popover, Text } from '@ui';
import { ReactComponent as InfoIcon } from 'resources/icons/remix-icons/information-line.svg';

const CertificationRequiredTooltip = () => {
  const { t } = useTranslation('onboarding');

  const tooltipRows = [
    t('application_documentation.certification_required_tooltip.item_1'),
    t('application_documentation.certification_required_tooltip.item_2'),
    t('application_documentation.certification_required_tooltip.item_3'),
    t('application_documentation.certification_required_tooltip.item_4'),
    t('application_documentation.certification_required_tooltip.item_5'),
    t('application_documentation.certification_required_tooltip.item_6'),
  ];

  const tooltipText = (
    <div>
      <StyledText>
        {t('application_documentation.certification_required_tooltip.text')}
      </StyledText>

      <StyledText>
        {t('application_documentation.certification_required_tooltip.text_1')}
      </StyledText>

      <ul>
        {tooltipRows.map((content, i) => (
          <li key={i}>{content}</li>
        ))}
      </ul>

      <StyledText>
        {t(
          'application_documentation.certification_required_tooltip.passport_title',
        )}
      </StyledText>
      <Text weight="semi-bold">
        {t(
          'application_documentation.certification_required_tooltip.passport_info',
        )}
      </Text>
      <StyledText>
        {t(
          'application_documentation.certification_required_tooltip.documents_title',
        )}
      </StyledText>
      <Text weight="semi-bold">
        {t(
          'application_documentation.certification_required_tooltip.documents_info',
        )}
      </Text>
      <StyledText>
        {t(
          'application_documentation.certification_required_tooltip.conclusion',
        )}
      </StyledText>
    </div>
  );

  return (
    <Popover content={tooltipText} placement="leftTop">
      <StyledIconSVG component={InfoIcon} color={colorsTheme.colorWarning} />
    </Popover>
  );
};

const StyledIconSVG = styled(IconSVG)`
  cursor: pointer;
`;

const StyledText = styled(Text)`
  margin-top: ${({ theme }) => theme.marginXs};
`;

export default CertificationRequiredTooltip;
